<template>
    <div v-if="data?.blog" class="grid gap-7 grid-cols-1 md:grid-cols-2">
        <div v-for="article in data.blog.articles" :key="article.id">            
            <UiYouTubeVideo :article="article" />
            <h4 class="mt-4">{{ article.title }}</h4>
            <div v-html="article.contenthtml"/>
        </div>

    </div>

</template>

<script setup lang="ts">
import { UiYouTubeVideo } from '#components';
import { useBlogStore } from '@/stores/blogStore';
const blogStore = useBlogStore();

const props = defineProps({
    article: {
        type: Object,
        required: true
    }
});

const { data, error } = await useAsyncData(props.article.handle, async () => {
    const [blogRes] = await Promise.all([
        blogStore.fetchBlogByHandle(props.article.handle)
    ]);

    return {
        blog: blogRes
    };
});



</script>